import { Directive } from '@angular/core';

@Directive({
  selector: '[appStopClickPropagation]',
  host: {
    '(click)': 'onclick($event)',
  },
})
export class StopClickPropagationDirective {
  onclick(e: MouseEvent): void {
    e.stopPropagation();
  }
}
